import { connect } from 'react-redux';
import { updateUser } from 'src/Actions/Admin/adminActions';
import UpdateUserModal from './UpdateUserModal';

const mapStateToProps = ({ admin }) => ({
  admin,
});

const mapDispatchToProps = (dispatch) => ({
  updateUser: (activationKey, isValid, email, searchKey) =>
    dispatch(updateUser(activationKey, isValid, email, searchKey)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserModal);
